import Loader from "./Loader"

const LoaderPage = () => {
    return(
        <div className="loader-container">
                <Loader />
        </div>
    )
}
export default LoaderPage